module.exports = __webpack_public_path__ + "img/dis_point1.2b48ceb1.png";